import { FC, ReactNode } from 'react';
import { AdvertContactDataItemType, useBotDetectorContext } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import { SocialLinkIcon } from '#advertDetail/components/social-link/SocialLinkIcon';
import socialLinkCss from '../../assets/social-link/social-link.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  socialLink: AdvertContactDataItemType;
};

const SocialLink: FC<PropsType> = ({
  socialLink,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();

  const wrapLink = (node: ReactNode): ReactNode => {
    if (!isBot && isDeleted) {
      return node;
    }

    if (!socialLink.url) {
      return node;
    }

    return (
      <a
        href={socialLink.url}
        target="_blank"
        rel="noreferrer"
        aria-label={`${socialLink.value} link`}
        className={socialLinkCss.socialLink__link}
      >
        {node}
      </a>
    );
  };

  return (
    <div
      className={classNames(
        socialLinkCss.socialLink,
        { [socialLinkCss.socialLink_withScaleOnHover]: isBot || !isDeleted },
      )}
    >
      {wrapLink(<SocialLinkIcon alias={socialLink.alias} />)}
    </div>
  );
};

export { SocialLink };
